// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__jRIb+","bg":"Popup_bg__3CmCx"};